module.exports = __webpack_public_path__ + "static/media/Welcome-Banner.07bb5335.gif";